import { render, staticRenderFns } from "./UserGhostMessage.vue?vue&type=template&id=1078d9ca&"
import script from "./UserGhostMessage.vue?vue&type=script&lang=js&"
export * from "./UserGhostMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports